import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Layout } from '../widgets'
import * as routes from '../routes'
import authClient from '../auth/authClient'
import { ProducerProfileContent } from './components'

export default class ProducerProfile extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    const user = authClient.currentUser()
    const profile = user.profile
    this.setState({
      username: user.username,
      profile: profile
    })
  }

  render() {
    const profileView = (
      <Layout className='profile-view'>
        <Layout.Header className='producer-profile__header'>
          Profile
          <Link className='btn--white' to={routes.producerProfileEditPath}>Edit Profile</Link>
        </Layout.Header>
        <ProducerProfileContent {...this.state} />
      </Layout>
    )

    return (
      <div className='body-container'>
        {profileView}
      </div>
    )
  }
}
